var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechnologySprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "scraping",
    viewBox: "0 0 116 116"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M81 73.382C75.856 80.42 67.467 85 58 85c5.277 0 9.876-5.632 12.332-14 3.312.565 6.822 1.362 10.668 2.382z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M70 71.072C67.61 79.397 63.131 85 58 85V70.001c3.897-.024 7.786.33 12 1.071zM58 81.555V85c-5.118 0-9.595-5.544-12-13.8 4.211-.775 8.107-1.179 12-1.2v11.555z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M45.636 71C48.114 79.375 52.727 85 58 85c-9.446 0-17.817-4.542-23-11.542 3.834-1.04 7.332-1.86 10.636-2.458zM30 57h14.075c0 4.974.701 9.634 1.925 13.635-3.277.575-6.748 1.364-10.551 2.365-3.424-4.48-5.445-10.01-5.445-15.997L30 57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M58 57v12.796c-3.925.021-7.854.426-12.1 1.204-1.208-4.112-1.9-8.892-1.9-14h14zm0 0h14c0 5.099-.678 9.882-1.856 14-4.264-.75-8.202-1.109-12.14-1.084V57H58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M71.887 57H86v.007C86 62.977 84.023 68.5 80.676 73c-3.85-1.005-7.361-1.785-10.676-2.34 1.198-4.018 1.887-8.685 1.887-13.66zM86 57H71.887c0-4.973-.689-9.64-1.887-13.66 3.315-.554 6.827-1.338 10.676-2.34C84.026 45.505 86 51.032 86 57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M72 58H58V45.084c3.942.025 7.877-.334 12.14-1.084 1.179 4.12 1.856 8.903 1.856 14H72zM58 45.204V58H44c0-5.106.692-9.89 1.9-14 4.246.778 8.175 1.183 12.1 1.204z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M46 43.366c-1.224 4.005-1.925 8.662-1.925 13.634H30c0-5.987 2.025-11.515 5.445-16 3.804 1.001 7.274 1.79 10.551 2.366H46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M58 30c-5.273 0-9.886 5.625-12.364 14-3.304-.599-6.802-1.418-10.636-2.458C40.183 34.542 48.554 30 58 30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M58 30v15c-3.893-.021-7.789-.425-12-1.2C48.405 35.543 52.882 30 58 30zm.004 0c5.127.003 9.607 5.607 11.996 13.928-4.214.74-8.107 1.095-12 1.07V30h.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M58 30c9.472 0 17.859 4.584 23 11.618-3.847 1.023-7.357 1.817-10.67 2.382-2.456-8.364-7.06-13.997-12.33-14z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 2.92,
    d: "M41 31v-7m5-5a5 5 0 1 1-10 0 5 5 0 0 1 10 0zm12 7V12m0 21v-3m5-23a5 5 0 0 1-4.998 5h-.004A5 5 0 1 1 63 7zm28 12a5 5 0 1 0 4.998-5A4.997 4.997 0 0 0 91 19z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 2.92,
    d: "M75 31V19h16M31 75h-7m-5-5a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm7-12H12m21 0h-3M7.002 53a5 5 0 1 1-.004 10 5 5 0 0 1 .004-10zM19 24a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm0 1v16h12m44 51v-7m-5 12a5 5 0 1 1 4.998 5A4.997 4.997 0 0 1 70 97zm-12 7V90m0-3.997V86m-5.16 22.838a5.159 5.159 0 1 1 10.316 0 5.157 5.157 0 1 1-10.316 0zM24.557 96.793a5.158 5.158 0 1 0-10.316 0 5.16 5.16 0 0 0 5.156 5.163 5.162 5.162 0 0 0 5.16-5.159v-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 2.92,
    d: "M41.036 84.805v11.994H24.555m67.084-55.571h-6.696m11.855 5.16a5.16 5.16 0 0 1-5.16-5.159 5.16 5.16 0 1 1 5.16 5.16zm6.882 11.616H89.757m-3.989 0h-3.483m26.556 5.154a5.161 5.161 0 1 1 .002-10.321 5.161 5.161 0 0 1-.002 10.32zM96.798 91.441a5.16 5.16 0 1 0 .002 10.322 5.16 5.16 0 0 0-.002-10.322zM84.824 74.959h11.975v16.48"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeMiterlimit: 10,
    strokeWidth: 2.92,
    d: "M58.004 30.268c9.287 0 17.508 4.556 22.549 11.545a27.588 27.588 0 0 1 5.216 16.183v.007c0 6.04-1.937 11.626-5.216 16.178C75.509 81.175 67.283 85.727 58 85.727c-9.283 0-17.364-4.471-22.415-11.363a27.562 27.562 0 0 1-5.35-16.365 27.6 27.6 0 0 1 5.35-16.368C40.636 34.739 48.795 30.268 58 30.268"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeMiterlimit: 10,
    strokeWidth: 2.92,
    d: "M71.94 57.996c0 5.032-.674 9.753-1.848 13.818C67.684 80.13 63.17 85.727 58 85.727c-5.17 0-9.634-5.538-12.049-13.783-1.202-4.097-1.89-8.86-1.89-13.948 0-5.09.688-9.852 1.89-13.945 2.415-8.245 6.91-13.783 12.05-13.783h.003c5.167.003 9.68 5.6 12.088 13.913 1.174 4.065 1.849 8.785 1.849 13.815zm-41.708.002h55.536"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeMiterlimit: 10,
    strokeWidth: 2.92,
    d: "M35.581 41.63c3.737 1.025 7.146 1.831 10.366 2.42 4.228.776 8.14 1.179 12.05 1.2 3.925.024 7.844-.33 12.09-1.07 3.248-.56 6.69-1.353 10.46-2.367M35.582 74.364c3.736-1.024 7.146-1.83 10.365-2.42 4.229-.774 8.141-1.178 12.05-1.199 3.926-.024 7.845.33 12.09 1.07 3.249.561 6.69 1.353 10.461 2.367M58 30.268v55.459"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "pds",
    viewBox: "0 0 108 107"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M70.335 73.446l10.519 6.232v12.46l-10.519 6.23-10.512-6.23v-12.46l10.512-6.232zm24.54-6.231L84.36 73.446l-10.517-6.231v-12.46l10.517-6.232 10.514 6.232v12.46zm-27.04 0l-10.512 6.231-10.52-6.231v-12.46l10.52-6.232 10.512 6.232v12.46zm8.012-36.667v4.393c-9.208-1.301-18.831 1.072-26.513 7.108a99.5 99.5 0 0 1-4.39.33 111.757 111.757 0 0 1-6.152.163 111.758 111.758 0 0 1-6.152-.163C15.1 41.427 1.737 36.495 1.737 30.548V13.632c0 6.626 16.59 11.994 37.052 11.994 20.46 0 37.044-5.365 37.05-11.99v16.912h.008zM39.085 50.66c.913 0 1.815-.011 2.711-.034a35.016 35.016 0 0 0-5.416 15.842c-19.364-.45-34.643-5.683-34.643-12.074v-15.84c0 3.228 3.905 6.164 10.262 8.333 6.806 2.325 16.422 3.772 27.082 3.772h.004zM43.8 92.292c-1.515.06-3.064.095-4.633.095-20.667 0-37.423-5.478-37.43-12.25v-16.66c0 6.48 15.377 11.787 34.838 12.223l.139-.02a35.613 35.613 0 0 0 7.085 16.615v-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 2.79,
    d: "M1.737 13.632c0-6.609 16.592-11.963 37.055-11.963s37.055 5.354 37.055 11.963c-.007 6.612-16.595 11.963-37.055 11.963S1.737 20.24 1.737 13.632zM11.756 46.53h-.004M1.737 54.91c0 6.389 15.158 11.62 34.368 12.07h.003m39.739-31.707v-21.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 2.79,
    d: "M49.33 42.442a35.331 35.331 0 0 0-7.852 8.703 35.186 35.186 0 0 0-5.374 15.838 35.564 35.564 0 0 0 .255 8.42 35.127 35.127 0 0 0 7.014 16.41 35.853 35.853 0 0 0 2.83 3.22c13.656 13.752 35.794 13.752 49.446 0 13.655-13.753 13.655-36.048 0-49.798-5.572-5.614-12.558-8.938-19.807-9.965a34.734 34.734 0 0 0-26.512 7.172z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 2.79,
    d: "M1.737 30.836c0 6 13.364 10.976 30.903 11.936a110.752 110.752 0 0 0 6.152.165 110.753 110.753 0 0 0 6.151-.165 98.984 98.984 0 0 0 4.391-.332M1.737 30.837V13.77m0 41.14V39.077c0 3.227 3.874 6.161 10.18 8.33 6.752 2.324 16.292 3.771 26.868 3.771.906 0 1.801-.01 2.69-.033.231-.004.463-.01.694-.017m1.204 40.684c-1.499.06-3.032.094-4.585.094-20.457 0-37.044-5.41-37.05-12.098V63.355c0 6.4 15.22 11.642 34.484 12.071m23.362 4.146v12.527l10.66 6.266 10.667-6.266V79.572l-10.667-6.265-10.66 6.265zM46.426 55.363V67.89l10.667 6.266 10.66-6.266V55.363l-10.66-6.265-10.667 6.265zm48.322 0V67.89l-10.66 6.266-10.663-6.266V55.363l10.663-6.265 10.66 6.265zm-37.652 6.37l-.004 8.284m7.038-12.418l-7.034 4.136m0-.001l-7.044-4.136m34.036 12.419l-.003-8.28m-.002.001l-7.034-4.14m14.08.001l-7.044 4.14m-6.796 20.076l-7.04 4.14m-.001 0l-7.038-4.14m7.039 12.454v-8.314"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "data",
    viewBox: "0 0 110 124"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M91.109 89.15c2.629 1.515 3.534 4.87 2.015 7.49-1.52 2.622-4.89 3.522-7.523 2.011a5.477 5.477 0 0 1-2.02-7.493c1.52-2.62 4.89-3.52 7.528-2.004v-.004zM16.01 73.216a5.464 5.464 0 0 1-2.02 7.485c-2.628 1.519-6.002.62-7.521-2.002a5.472 5.472 0 0 1 2.015-7.49c2.632-1.514 6.006-.615 7.525 2.01v-.003zm38.793-16.698c3.318 0 6.01 2.675 6.01 5.981s-2.692 5.981-6.01 5.981c-3.317 0-6.009-2.68-6.009-5.981 0-3.302 2.692-5.981 6.01-5.981zM65.319 23.62c3.042 0 5.508-2.456 5.508-5.484s-2.466-5.483-5.508-5.483-5.509 2.455-5.509 5.483c0 3.029 2.467 5.483 5.509 5.483z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeMiterlimit: 10,
    strokeWidth: 3.27,
    d: "M66.988 27.229a157.065 157.065 0 0 1 1.506 10.306c.561 4.902.956 10.149 1.166 15.64.11 2.879.166 5.828.166 8.825 0 2.997-.056 5.947-.166 8.826-.21 5.49-.605 10.738-1.166 15.64-2.415 21.118-7.86 35.847-14.191 35.847s-11.777-14.729-14.191-35.848a207.689 207.689 0 0 1-1.166-15.64A230.05 230.05 0 0 1 38.78 62c0-2.997.055-5.946.166-8.825.21-5.491.604-10.738 1.166-15.64 2.414-21.119 7.86-35.847 14.19-35.847 2.526 0 4.917 2.348 7.027 6.512"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeMiterlimit: 10,
    strokeWidth: 3.27,
    d: "M65.319 23.62c3.042 0 5.508-2.456 5.508-5.484s-2.466-5.483-5.508-5.483-5.509 2.455-5.509 5.483c0 3.029 2.467 5.483 5.509 5.483zm-4.507 38.879c0 3.302-2.691 5.981-6.009 5.981-3.317 0-6.009-2.68-6.009-5.981 0-3.302 2.692-5.981 6.01-5.981 3.317 0 6.008 2.675 6.008 5.981z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeMiterlimit: 10,
    strokeWidth: 3.27,
    d: "M18.191 67.932a157.079 157.079 0 0 1 8.215-6.43c3.985-2.93 8.362-5.886 13.035-8.8a231.807 231.807 0 0 1 7.598-4.538 235.22 235.22 0 0 1 7.764-4.257A209.73 209.73 0 0 1 69 37.112c19.588-8.455 35.141-11.114 38.304-5.674 3.166 5.44-6.931 17.462-24.108 30.064a209.226 209.226 0 0 1-13.03 8.8 238.719 238.719 0 0 1-15.363 8.795 209.682 209.682 0 0 1-14.196 6.794C21.014 94.342 5.469 97.005 2.303 91.566c-1.265-2.174-.411-5.397 2.158-9.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeMiterlimit: 10,
    strokeWidth: 3.27,
    d: "M8.484 70.212c2.632-1.514 6.006-.615 7.525 2.01a5.46 5.46 0 0 1-2.018 7.483c-2.629 1.517-6.003.618-7.522-2.002a5.469 5.469 0 0 1 2.015-7.487v-.004zm70.241 19.525A160.556 160.556 0 0 1 69 85.896 210.622 210.622 0 0 1 54.803 79.1a250.436 250.436 0 0 1-7.764-4.257 234.431 234.431 0 0 1-7.598-4.538c-4.677-2.918-9.05-5.874-13.034-8.8C9.233 48.9-.863 36.878 2.303 31.44c3.167-5.444 18.711-2.777 38.304 5.674a209.749 209.749 0 0 1 14.196 6.794 238.906 238.906 0 0 1 15.363 8.796 209.237 209.237 0 0 1 13.03 8.8c17.177 12.605 27.274 24.627 24.108 30.063-1.265 2.17-4.507 3.05-9.184 2.788"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeMiterlimit: 10,
    strokeWidth: 3.27,
    d: "M85.6 98.647c-2.632-1.514-3.537-4.869-2.018-7.49 1.52-2.618 4.89-3.518 7.527-2.003 2.629 1.514 3.534 4.868 2.015 7.486-1.52 2.622-4.89 3.522-7.523 2.011v-.004zM15.746 39.072a.5.5 0 0 1-1.002 0 .5.5 0 0 1 1.002 0zm38.304 68.354a.504.504 0 0 1 .685.181.496.496 0 0 1-.183.682.504.504 0 0 1-.684-.181.502.502 0 0 1 .182-.682zm40.061-67.923a.5.5 0 1 1 .501-.863.5.5 0 1 1-.501.863z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "did",
    viewBox: "0 0 104 148"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M101.991 70.568c.197 10.87-4.17 20.322-12.977 28.047-6.62 5.805-14.674 9.679-21.146 12.787-3.4 1.629-7.248 3.48-8.684 4.666L52.001 122l-7.188-5.932c-1.44-1.186-5.284-3.037-8.674-4.666-6.482-3.108-14.537-6.982-21.156-12.787C6.176 90.89 1.81 81.437 2.006 70.528V14.743h11.248c13.133 0 19.715 0 32.463-8.535L52.005 2l6.285 4.208c12.743 8.535 19.334 8.535 32.462 8.535H102v55.825h-.009zm-49.99 36.898C61.285 99.8 91.23 94.135 90.748 70.654v-44.73c-14.225 0-23.458-.208-38.747-10.444-15.289 10.236-24.527 10.444-38.752 10.444v44.73C12.763 94.13 42.712 99.8 52.001 107.466z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.78,
    d: "M44.81 116.068c-1.44-1.186-5.284-3.037-8.673-4.666-6.482-3.108-14.536-6.982-21.155-12.787C6.176 90.89 1.81 81.437 2.006 70.528V14.743h11.247c13.132 0 19.714 0 32.46-8.535L52.004 2l6.283 4.208c12.742 8.535 19.334 8.535 32.46 8.535h11.248v55.825c.197 10.87-4.17 20.322-12.976 28.047-6.62 5.805-14.674 9.679-21.145 12.787-3.4 1.629-7.248 3.48-8.683 4.666L52.007 122l-7.188-5.932h-.009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.78,
    d: "M52.002 108c-9.343-7.667-39.48-13.333-38.996-36.817V26.445c14.314 0 23.606-.208 38.996-10.445C67.383 26.237 76.68 26.445 90.994 26.445v44.738c.485 23.48-29.644 29.15-38.992 36.817z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M68.782 43L76 50.289 49.295 78 28 57.98l7.098-7.403 14.09 13.033 15.088-15.876"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 3.78,
    d: "M68.782 43L76 50.289 49.295 78 28 57.98l7.098-7.403 14.09 13.033 15.088-15.876"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M4 146l5.502-5.5L15 135"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.78,
    d: "M4 146l5.502-5.5L15 135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M15 146l-5.498-5.5L4 135"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.78,
    d: "M15 146l-5.498-5.5L4 135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M32 146l5.5-5.5L43 135"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.78,
    d: "M32 146l5.5-5.5L43 135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M43 146l-5.5-5.5L32 135"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.78,
    d: "M43 146l-5.5-5.5L32 135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M60 146l5.498-5.5L71 135"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.78,
    d: "M60 146l5.498-5.5L71 135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M71 146l-5.502-5.5L60 135"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.78,
    d: "M71 146l-5.502-5.5L60 135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M89 146l5.502-5.5L100 135"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.78,
    d: "M89 146l5.502-5.5L100 135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M100 146l-5.498-5.5L89 135"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.78,
    d: "M100 146l-5.498-5.5L89 135"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "blockchain",
    viewBox: "0 0 126 143"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M109 122.949V141l-16-9.032v-18.046h.004L109 122.949z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M108 122.946h.009L124 113.922v18.045L108 141v-18.054z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M124 113.922v.005l-15.494 9.021h-.008L93 113.922l15.498-9.026L124 113.922zm-90 0v18.049L18 141v-18.054l15.996-9.024H34zm-16.004 9.026H18V141l-16-9.03v-18.048l15.996 9.026z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M17.5 104.896l15.5 9.026-15.5 9.022v.004h-.004L2 113.927v-.005l15.5-9.026zm.496-84.846l.004.004v18.05L2.004 29.07 2 11.025l15.996 9.025zm16-9.025L34 29.077l-15.996 9.026V20.051L18 20.047l15.987-9.022h.009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M17.5 2L33 11.032l-15.492 9.02L2 11.028v-.008L17.5 2zM124 11.026l-15.498 9.026h-.004L93 11.022 108.498 2 124 11.026z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M109 20.057v18.046l-16-9.027V11.029l.008-.004L109 20.057z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M108.004 20.054L124 11.025v18.05l-16 9.028V20.054h.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M108.502 38.104L93 29.076V11.028l.008-.004L108.502 2 124 11.028v18.048l-15.498 9.028z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M124 11.025l-16 9.026m0 18.054V20.053"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M109 20.051h-.004L93 11.025"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M109 20.051h-.004L93 11.025"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M67 20.05c0 2.491-2.013 4.515-4.496 4.515A4.514 4.514 0 0 1 58 20.05a4.506 4.506 0 0 1 4.504-4.51A4.501 4.501 0 0 1 67 20.05z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M63 29.98v10.832m0 63.182v9.929m9-93.87h15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M32.988 11.258L17.494 2 2 11.245v.009l.004 18.494 15.502 9.259L33 29.757l-.004-18.499h-.008z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M18 38.105V20.053"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M34 11.025l-.008.005L18 20.05"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M34 11.025l-.008.005L18 20.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M18 20.051l-.004-.004L2 11.025"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M18 20.051l-.004-.004L2 11.025"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M17.504 66.084c2.482 0 4.496 2.024 4.496 4.515a4.504 4.504 0 0 1-4.496 4.511A4.51 4.51 0 0 1 13 70.599a4.509 4.509 0 0 1 4.504-4.515z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M27 70.598h9m-18-9.027v-17.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 113.929v18.043L17.498 141 33 131.972v-18.047h-.004l-15.498-9.029L2 113.925"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M2 113.929v18.043L17.498 141 33 131.972v-18.047h-.004l-15.498-9.029L2 113.925"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M2 113.922h.004v.004L18 122.948"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M2 113.922h.004v.004L18 122.948"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M18 140.999v-18.052"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M18 140.999v-18.052"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M18 122.948h.004v-.004L34 113.922"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M18 122.948h.004v-.004L34 113.922"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M108.5 141L93 131.969v-18.046h.004l15.496-9.027 15.5 9.027v18.046L108.5 141z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M124 113.922l-16 9.026m0 18.051v-18.052"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M109 122.948h-.008L93 113.922"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M109 122.948h-.008L93 113.922"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M58 122.947a4.506 4.506 0 0 1 4.5-4.511c2.484 0 4.5 2.019 4.5 4.511a4.507 4.507 0 0 1-4.5 4.515 4.507 4.507 0 0 1-4.5-4.515z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M54 122.947H39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M108.5 75.11a4.51 4.51 0 0 1-4.5-4.513 4.507 4.507 0 0 1 4.5-4.513c2.484 0 4.5 2.02 4.5 4.513a4.505 4.505 0 0 1-4.5 4.513z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M99 70.598h-9m18 9.927v18.052"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M63.002 97.675c-5.27-4.285-22.275-7.457-21.999-20.588V52.07c8.073 0 13.32-.116 22-5.843 8.675 5.727 13.92 5.843 21.994 5.843v25.017c.276 13.13-16.724 16.303-21.995 20.588z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M63 97.675V78.721"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.28,
    d: "M63 97.675V78.721m0-13.54V46.227M58 71.5H41m45 0H69"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "ai",
    viewBox: "0 0 122 111"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M120 79v16H2V79h118zM34 35.002V53l-15-8.999V26l15 9.002zM49 26v18.001L34 53V35.002L49 26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M50 25.996L34.5 35 19 25.996 34.5 17 50 25.996z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.09,
    d: "M19 25.996V44l15.5 9L50 44V25.996L34.5 17 19 25.996z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.09,
    d: "M34 35v18m15-27l-15 9m-15-9l15 9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.09,
    d: "M2 79.397V2h118v93H2V79.397z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.09,
    d: "M2 80h118"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M55 87h12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.09,
    d: "M55 87h12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M39 109h45"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 3.09,
    d: "M39 109h45m-11 0v-9m-22 9V95m56-78H74m33 12H74m33 12H74m33 12H74m32 12H19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33 33.336V50l-14-8.332V25l14 8.336zM47 25v16.668L33 50V33.336L47 25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47 25.498L33.003 34 19 25.498 33.003 17 47 25.498z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 2.8,
    d: "M19 25.25v16.5L33.003 50 47 41.75v-16.5L33.003 17 19 25.25z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#555",
    strokeLinejoin: "round",
    strokeWidth: 2.8,
    d: "M33 34v16m14-25l-14 8m-14-8l14 8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 81h116v13H3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnologySprite);
export default __webpack_public_path__ + "static/media/technology-sprite.1c07573e521158366889280b4c37f025.svg";
export { ForwardRef as ReactComponent };